import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useProject } from '../../../../../context/ProjectContext';

function useUsedMediaItems() {
  const { actions } = useProject();

  const sessionId = useSelector((state) => state.story.sessionId);
  const items = useSelector((state) => state.story.usedMedia);
  const generatedContent = useSelector((state) => state.story.generatedContent);

  useEffect(() => {
    actions('getUsedMedia', { sessionId });
  }, [actions, sessionId, generatedContent.length]);

  return { items };
}

export default useUsedMediaItems;
